import React from 'react';
import { FormLabel as MuiFormLabel } from '@mui/material';
import { labelStyles } from './form-label-helper';

interface FormLabelProps {
    text: React.JSX.Element | string;
    required?: boolean;
    condensed?: boolean;
    focused?: boolean;
}

export const FormLabel = (props: FormLabelProps): React.JSX.Element => {
    const { text, condensed = false, required, focused = false } = props;

    const getTopMargin = (): string => {
        if (!condensed) {
            return '8px';
        } else return '0';
    };

    const getBottomMargin = (): string => {
        if (!condensed) {
            return '1px';
        } else return '0';
    };

    return (
        <MuiFormLabel
            required={required}
            sx={{
                mb: getBottomMargin(),
                mt: getTopMargin(),
                ...labelStyles,
            }}
            focused={focused}
        >
            {text}
        </MuiFormLabel>
    );
};
